module.exports = __webpack_public_path__ + "static/media/btn_listeningvoice26eb09ae1ed7f53ed3035596a36776a4.webp";